export enum HsLightType {
  Light = 'Light',
  Ambient = 'Ambient Light',
  Directional = 'Directional Light',
  Point = 'Point Light',
  Spotlight = 'Spotlight',
}
